import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { Button, Form, FormGroup, FormControl, Row, Col, ControlLabel, Panel } from 'react-bootstrap';
import _ from 'lodash';

import CitiesComponent from './settings/components/CitiesComponent';
import CountriesComponent from './settings/components/CountriesComponent';
import { gettext, setLocale } from '../i18n/service.js';
import getCurLang from '../businessLogic/getCurLang.js';
import { paddingZero, textToLeft} from '../constants/loginStyle.js';

const lan = getCurLang();

export default class RegisterForm extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      language: "en"
    };
  }

  setTimezone(e) {
    this.setState({timezone: e.target.value});
    this.props.setTimezone(e.target.value);
  }

  render() {

    return (
      <Panel className="centerRegisterForm">
        <Form horizontal className="insideRegisterForm"  action="" dir = {getCurLang()==='ar'?'rtl':'ltr'}  onSubmit={this.props.submit}>
        
          <FormGroup controlId="formHorizontalName">
            <Row>
              {(lan==='en' || lan==='ru')?
                <Col componentClass={ControlLabel} sm={4} style={textToLeft}>
                  { gettext('NAME') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="text" placeholder="Name" name="name"  />
                </Col>
              }
              {(lan==='ar')?
                <Col componentClass={ControlLabel} sm={4} style={paddingZero}>
                  { gettext('NAME') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="text" placeholder="Name" name="name" />
                </Col>
              }
            </Row>            
          </FormGroup>
          <FormGroup controlId="formHorizontalCompany">
            <Row>
              {(lan==='en' || lan==='ru')?
                <Col componentClass={ControlLabel} sm={4} style={textToLeft}>
                  { gettext('COMPANY-NAME') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="text" placeholder="Company Name" name="company"  />
                </Col>
              }
              {(lan==='ar')?
                <Col componentClass={ControlLabel} sm={4} style={paddingZero}>
                  { gettext('COMPANY-NAME') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="text" placeholder="Company Name" name="company" />
                </Col>
              }
            </Row>
          </FormGroup>
          <FormGroup controlId="formHorizontalEmail">
            <Row>
              {(lan==='en' || lan==='ru')?
                <Col componentClass={ControlLabel}  sm={4} style={textToLeft}>
                  { gettext('EMAIL') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="email" placeholder="Email" name="email"  />
                </Col>
              }
              {(lan==='ar')?
                <Col componentClass={ControlLabel} sm={4} style={paddingZero}>
                  { gettext('EMAIL') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="email" placeholder="Email" name="email" />
                </Col>
              }
            </Row>
          </FormGroup>
          <FormGroup controlId="formHorizontalPassword">
            <Row>
              {(lan==='en' || lan==='ru')?
                <Col componentClass={ControlLabel} sm={4} style={textToLeft}>
                  { gettext('PASSWORD') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="password" placeholder="Password" name="password"/>
                </Col>
              }
              {(lan==='ar')?
                <Col componentClass={ControlLabel} sm={4} style={paddingZero}>
                  { gettext('PASSWORD') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="password" placeholder="Password" name="password"/>
                </Col>
              }
            </Row>
          </FormGroup>
          <FormGroup controlId="formHorizontallConFirmPassword">
            <Row>
              {(lan==='en' || lan==='ru')?
                <Col componentClass={ControlLabel} sm={4} style={textToLeft}>
                  { gettext('CONFIRM-PASSWORD') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="password" placeholder="Confirm Password" name="confirmPassword"/>
                </Col>
              }
              {(lan==='ar')?
                <Col componentClass={ControlLabel} sm={4} style={paddingZero}>
                  { gettext('CONFIRM-PASSWORD') }
                </Col>:
                <Col sm={8}>
                  <FormControl type="password" placeholder="Confirm Password" name="confirmPassword"/>
                </Col>
              }
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col sm={12}>
                <Button type="submit" className="submit">
                  { gettext('AUTH.SIGN-UP') }
                </Button>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col sm={12}>
                Do you have account already? <Link to="/login">{gettext('AUTH.SIGN-IN')}</Link>
              </Col>
            </Row>
          </FormGroup>
        </Form>
      </Panel>
    );
  } 
}

RegisterForm.propTypes = {
  submit: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/RegisterForm.js